<template>
  <div class="flex flex-col items-center gap-y-3.5">
    <UiIcon class="mx-auto w-20 flex-1 text-primary" name="search-no-results" />
    <p class="text-md font-medium capitalize text-gray-bag">
      {{ $t("noResultsFound") }}
    </p>
    <p class="text-center text-sm">{{ $t("noResultsFoundText") }}.</p>
  </div>
</template>
